import { Component } from 'solid-js';
import styles from './LoadingBar.module.scss';

export const LoadingBar: Component = () => {
  return <div class={styles.container}></div>;
};
